import React from "react";
import './Body18.css';
import {Link} from "react-router-dom"
import picture301 from './source/picture301.png'
import picture302 from './source/picture302.png'
import picture303 from './source/picture303.png'
import picture304 from './source/picture304.png'





function Body18() {

  return (
    <div className="body18">
      <div className="body18-box1">
        <div className="body18-box2">
          <div className="body18-box3">Zlín</div>
          <div className="body18-box5"><div className="body18-box4"></div></div>
          <div className="body18-box6">
          <img className="body18-box6-picture" src={picture301} alt="picture1"/>
          <img className="body18-box6-picture" src={picture302} alt="picture1"/>
          <img className="body18-box6-picture2" src={picture303} alt="picture1"/>
          <img className="body18-box6-picture2" src={picture304} alt="picture1"/>
          </div>
          <div className="body18-box8"><div className="body18-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body18;
